<template>
  <van-overlay :show="value" @click.stop="hideOverlay" z-index="100">
    <div class="content" v-if="postion">
      <div class="text" v-html="title"></div>
      <div
        class="lottie-content"
        :style="{ left: postion.x + 'px', top: postion.y + 'px' }"
        @click.stop="bindClickBth"
      >
        <div id="lottie-icon" class="lottie-icon"></div>
        <!--  <lottie-player
          class="lottie-icon"
          autoplay
          loop
          src="https://gymvue.gymcity.com.cn/betterwe_app/%E6%8C%89%E9%92%AE%E7%82%B9%E5%87%BB%E5%8A%A8%E6%95%88.json"
        >
        </lottie-player> -->
      </div>
      <TutorialTip
        v-model="showTutorial"
        @click="bindNextTip"
        :options="tipsOptions"
      ></TutorialTip>
    </div>
  </van-overlay>
</template>
<script>
import lottie from 'lottie-web'
import TutorialTip from './tutorial.vue'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    cupType: {
      type: Number,
      default: 1
    }
  },
  components: {
    TutorialTip
  },
  data() {
    return {
      postion: null,
      showTutorial: false,
      tipsOptions: {
        id: 'clock-btn',
        top: -10,
        direction: 'top',
        textAlign: 'center',
        text: '点击灌满彩虹杯'
      }
    }
  },
  computed: {},
  watch: {
    postion() {
      if (this.postion) {
        this.$nextTick(() => {
          this.loadLottieAnimation()
        })
      }
    },
    value() {
      setTimeout(() => {
        this.updatePosition()
      }, 200)
    },
    cupType: {
      immediate: true,
      handler() {
        this.tipsOptions.text =
          this.cupType == 1 ? '点击灌满彩虹杯' : '点击灌满水杯'
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.updatePosition()
    }, 200)
  },
  methods: {
    loadLottieAnimation() {
      if (this.playAnimation) {
        return
      }
      this.playAnimation = true
      console.log('播放动画')
      this.lottie = lottie.loadAnimation({
        container: document.getElementById('lottie-icon'), // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: 'https://gymvue.gymcity.com.cn/betterwe_app/%E6%8C%89%E9%92%AE%E7%82%B9%E5%87%BB%E5%8A%A8%E6%95%88.json' // the path to the animation json
      })
    },
    bindNextTip() {},
    hideOverlay() {
      this.$emit('input')
    },
    bindClickBth() {
      this.$emit('input')
      this.$emit('click')
    },
    updatePosition() {
      let el = document.getElementsByClassName('clock-image')[0]
      if (!el) {
        return
      }
      el.scrollIntoView(false)
      setTimeout(() => {
        let x = el.getBoundingClientRect().left + el.clientWidth / 2
        let y = el.getBoundingClientRect().top + el.clientHeight / 2
        this.postion = {
          x,
          y
        }
        this.showTutorial = true
      }, 200)
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
}
.text {
  width: 286px;
  margin: 0 auto;
  margin-top: 39vh;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 24px;
}
.lottie-content {
  position: absolute;
  width: 180px;
  height: 180px;
  transform: translate(-50%, -50%);
  z-index: 2200;
}
.lottie-icon {
  width: 100%;
  height: 100%;
}
</style>
